import React from "react";
import ChatBotMessage from "./ChatBotMessage";

const ChatBotMessages = ({ messages, isLoading, messagesEndRef, onSelectPrompt, onSelectFollowUp, selectedLanguage = "english" }) => {
  const quickPrompts = {
    english: [
      "What is MyBOQ?",
      "Pricing plans",
      "AI Roadmap",
      "Public Sector tools",
      "Getting started",
    ],
    marathi: [
      "MyBOQ काय आहे?",
      "किंमत योजना",
      "AI रोडमॅप",
      "पब्लिक सेक्टर साधने",
      "सुरुवात करणे",
    ]
  };

  const currentPrompts = quickPrompts[selectedLanguage] || quickPrompts.english;

  return (
    <div
      className="flex-1 overflow-y-auto p-4 space-y-4 custom-scrollbar"
      style={{ scrollBehavior: 'smooth' }}
    >
      {messages.length === 1 && !isLoading && (
        <div className="animate-fade-in-up space-y-3">
          <div className="text-center text-slate-500 text-sm py-2">
            <span className="font-semibold text-orange-600">BOQ AI</span> {selectedLanguage === "marathi" ? "तुम्हाला खालील गोष्टींमध्ये मदत करू शकते:" : "can help you with:"}
          </div>
          <div className="grid grid-cols-2 gap-2 max-w-xs mx-auto">
            {currentPrompts.map((prompt, i) => (
              <button
                key={i}
                onClick={() => onSelectPrompt(prompt)}
                className="bg-white border border-slate-200 hover:border-orange-300 hover:bg-orange-50 text-slate-700 text-sm font-medium px-3 py-2 rounded-xl transition-all hover:shadow-md hover:-translate-y-0.5 text-left"
              >
                {prompt}
              </button>
            ))}
          </div>
          <p className="text-center text-[11px] text-slate-400 mt-2">
            {selectedLanguage === "marathi" ? "किंवा BOQ, अंदाज, SSR दर बद्दल काहीही विचारा..." : "Or ask anything about BOQ, estimation, SSR rates..."}
          </p>
        </div>
      )}

      <div className="space-y-3">
        {messages.map((msg) => (
          <div key={msg.id}>
            <ChatBotMessage message={msg} onSelectFollowUp={onSelectFollowUp} />
          </div>
        ))}
      </div>

      {isLoading && (
        <div className="flex items-start gap-3 animate-slide-in">
          <div className="w-7 h-7 rounded-xl bg-gradient-to-br from-orange-500 to-amber-500 flex items-center justify-center flex-shrink-0 shadow-sm">
            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
          </div>
          <div className="bg-slate-100 rounded-2xl rounded-tl-md px-4 py-3 max-w-[80%] animate-pulse">
            <div className="flex gap-1 h-4">
              <div className="w-8 h-4 bg-slate-200 rounded animate-pulse" style={{animationDelay: '0ms'}} />
              <div className="w-10 h-4 bg-slate-200 rounded animate-pulse" style={{animationDelay: '100ms'}} />
              <div className="w-6 h-4 bg-slate-200 rounded animate-pulse" style={{animationDelay: '200ms'}} />
            </div>
            <div className="mt-2 flex gap-1 h-4">
              <div className="w-6 h-4 bg-slate-200 rounded animate-pulse" style={{animationDelay: '300ms'}} />
              <div className="w-8 h-4 bg-slate-200 rounded animate-pulse" style={{animationDelay: '400ms'}} />
            </div>
          </div>
        </div>
      )}

      <div ref={messagesEndRef} />
    </div>
  );
};

export default ChatBotMessages;